export default __webpack_public_path__ + "static/imgFourteen-8434c4e3e19d897430eb61056aa360fb.jpg";